import { Box, Typography } from '@mui/material';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import React from 'react';
import { Card } from 'Components/Card'


export const SummaryCard = ({ title, value }) => {
  return (
    <Card className="p-3">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="body1" fontWeight="bold">{title}</Typography>
        <Box sx={{ border: "1px solid #0039c4", padding: 1, borderRadius: "12px", display: "flex" }}>
          <FactCheckIcon sx={{ color: "#0039c4" }} />
        </Box>
      </Box>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h5" fontWeight="bold" fontSize="1.45rem">{value}</Typography>
      </Box>
    </Card>
  );
};